/**
 * Configuration object
 */
const config = {
    /** @member {String} environment The one from 'PRODUCTION', 'DEVELOPMENT' */
    environment: 'PRODUCTION',

    /** @member {String} version Application version */
    version: '1.0.24',

    /** @member {String} customChannel Namespace for custom message channel */
    customChannel: 'urn:x-cast:com.rte.chromecast',

    /** @member {String} streamType The RTE stream type */
    streamType: 'fincons',

    accountId: '1uC-gC', // dev: '9nl_gC',, prod: 1uC-gC

    /** @member {String} endpoint Endpoint URL returning SMIL (including Stream URL and Ads URL) */
    endpoint: 'https://link.theplatform.eu/s/[account]/media/[media]?auth=[auth]&sdk=PDK%205.7.16&formats=[formats]&format=SMIL&embedded=true&tracking=true',

    /** @member {String} drmType DRM type. The one from 'widevine', 'playready' */
    drmType: 'widevine',

    /** @member {Bollean} subtitleFilter */
    subtitleFilter: true,

    /** @member {String} configUrl Returning configuration for App */
    configUrl: 'https://www.rte.ie/wordpress/wp-content/uploads/standard/smartott/config.json',

    /**
     * @member {Bollean} dvrWindowLength DVR window length in seconds.
     * The additional property included in live stream request. TMGRIS-40
     */
    dvrWindowLength: 30
};

if (config.environment === 'DEVELOPMENT') {
    // config.configUrl = 'https://pl-cms-test.rte.host/wordpress/wp-content/uploads/standard/smartott/config.json';
}

export default config;
